module.exports = __webpack_public_path__ + "build_instructions_full_1.png?5b204bd89c55a537464f0718340251f5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/build_instructions_full_1.png
// module id = 442
// module chunks = 0